export default function CheckContent({ content }) {
  return (
    <div
      className="flex items-center pb-c2 justify-start 
      || text-base text-black222 || pb-c2"
    >
      {content}
    </div>
  );
}
